/* eslint-disable no-global-assign */
import { getScript, i18n, countryLangs } from '@/commons/utils';
import { displayError, callAjaxBookOrder, checkBillingAddress } from '@/checkout/payment/payment';

let payButtons = [];
let isExpress = false;

// eslint-disable-next-line consistent-return
export const init = isExpressCheckout => {
  // If user abort a payment before finishing and go back on the widget page, refresh the page:
  if (
    (performance.getEntriesByType &&
      performance.getEntriesByType('navigation') &&
      performance.getEntriesByType('navigation').length > 0 &&
      performance.getEntriesByType('navigation')[0].type === 'back_forward') ||
    (performance.navigation && performance.navigation.type === 2)
  ) {
    return window.location.reload(true);
  }

  isExpress = isExpressCheckout;

  const onePaySettings = parseWidgetData(document.getElementById('js-widget-data').innerHTML);
  window.onePay = enrichWidgetData(onePaySettings);

  window.OnePayConfiguration = {
    serversURLConstant: {
      BASE_URL: window.location.origin,
    },
  };

  if(window && window.decathlon)
    window.decathlon.jq = jQuery;

  getScript(onePaySettings.config.onePayFrontUrl, true).then(() => {
    const selectPickers = document.querySelectorAll('#dkt-payment-kit select');
    selectPickers.forEach(elem => {
      elem.style.display = 'none';
    });

    if (selectPickers.length > 0) {
      $('#dkt-payment-kit select').selectpicker();
    }

    //only on checkout payment and not in product page
    if (
      document.body.classList.contains('checkout-payment') &&
      $('.dkt-checkout-actions').attr('data-async-booking') === 'true'
    ) {
      callAjaxBookOrder();
    }

    setTimeout(() => {
      if(window && window.decathlon && window.decathlon.jq) {
        $ = window.decathlon.jq;
        jQuery = window.decathlon.jq;
      }
    }, 1500);
  });

  handlePaymentError();
  initButtonsEvent();
  displayPrivacyRules();
};

function handlePaymentError() {
  const hasPaymentError = document.querySelector('.js-has-error');

  if (hasPaymentError) {
    const countdownContent = $('#alert-wrapper .wrapper .text').html();

    displayError(i18n('payment.error.message'), {
      onClose: () => {
        displayError(countdownContent, {
          type: 'info',
          icon: 'animate-icon chrono',
          delay: 0,
        });
        window.decathlon.tools.countdown($('.countdown'));
      },
    });
  }
}

function initButtonsEvent() {
  document.addEventListener('clickedOnPay', preparePayment);
  document.addEventListener('paymentEnability', event => {
    if (event.detail.enabled) {
      enableButton();
    } else {
      disableButton();
    }
  });

  document.addEventListener('paymentAuthError', () => {
    hideLoader();
    cube.alert.error(i18n('payment.onepay.authenticationerror.message'));
    setTimeout(() => window.location.reload(), 4000);
  });

  bindPayButtons();
  cube.event.on('reinit-checkout-billing-address', bindPayButtons);

  document.addEventListener('closeExpress', () => {
    document.removeEventListener('clickedOnPay', preparePayment);
  });
}

const isCheckboxPresent = () => document.getElementById('acceptConditions') !== null;

function doPayment() {
  if (!isExpress && !checkBillingAddress()) return;

  if (!isCheckboxPresent() || (isCheckboxPresent() && document.getElementById('acceptConditions').checked)) {
    disableButton();
    displayLoader();

    window.onePay.processPayment();
  } else {
    cube.alert.error(i18n('delivery.shippingorder.checkboxError'));
  }
}

const enableButton = () => {
  [...payButtons].forEach(button => {
    button.classList.remove('disabled');
    button.disabled = false;
  });
};

const disableButton = () => {
  [...payButtons].forEach(button => {
    button.classList.add('disabled');
    button.disabled = true;
  });
};

const preparePayment = () => {
  if ($('.dkt-checkout-actions').attr('data-async-booking') === 'true') {
    callAjaxBookOrder().then(() => {
      doPayment();
    });
  } else {
    doPayment();
  }
};

const bindPayButtons = () => {
  payButtons = document.querySelectorAll(
    isExpress ? '.dkt-express-checkout-footer-pay' : '.dkt-checkout-primary-button'
  );
  $('body')
    .off('click', '.dkt-checkout-primary-button')
    .on('click', '.dkt-checkout-primary-button', preparePayment);
};

const displayLoader = () => {
  if (isExpress) {
    const span = document.createElement('span');
    span.id = 'expressCheckoutLoading';
    span.classList.add('dkt-loader');
    $('.dkt-sliding-panel-inner').after(span);
  } else {
    document.body.classList.add('loading');
  }
};

const hideLoader = () => {
  if (isExpress) {
    $('#expressCheckoutLoading').remove();
  } else {
    document.body.classList.remove('loading');
  }
};

function displayPrivacyRules() {
  cube.cartridge('privacy-rules-section').reload({ context: 'PaymentPage' });
}

function parseWidgetData(stringWidgetData) {
  const jsonWidgetData = JSON.parse(stringWidgetData, parseBooleanValues);

  jsonWidgetData.config = JSON.parse(jsonWidgetData.config, parseBooleanValues);
  jsonWidgetData.data = JSON.parse(jsonWidgetData.data, parseBooleanValues);
  jsonWidgetData.meanOfPaymentList = JSON.parse(jsonWidgetData.meanOfPaymentList, parseBooleanValues);

  if (jsonWidgetData.config.homeUrl === '') {
    jsonWidgetData.config.redirectionUrl = prependHostToUrl(jsonWidgetData.config.redirectionUrl);
    jsonWidgetData.config.paymentUrl = prependHostToUrl(jsonWidgetData.config.paymentUrl);
    jsonWidgetData.config.declineUrl = prependHostToUrl(jsonWidgetData.config.declineUrl);
    jsonWidgetData.config.orderTrackingUrl = prependHostToUrl(jsonWidgetData.config.orderTrackingUrl);
  }

  return jsonWidgetData;
}

function prependHostToUrl(url) {
  const countryLanguages = countryLangs();
  const activeLanguage = window.tc_vars.env_language;
  if (countryLanguages.length > 1) {
    return `${window.location.origin}/${activeLanguage}/${url.replace(/^\/|\/$/g, '')}`;
  }
  return `${window.location.origin}/${url.replace(/^\/|\/$/g, '')}`;
}

function enrichWidgetData(onePaySettings) {
  return {
    config: Object.assign(onePaySettings.config, {
      additionnalInformations: [onePaySettings.config.additionnalInformations],
      encryptToken: true,
    }),
    data: onePaySettings.data,
    meanOfPaymentList: onePaySettings.meanOfPaymentList,
    notifier: {
      success: () => {},
      error: message => {
        console.error('OnePay Error: ', message);
        hideLoader();
      },
      preSubmit: () => {
        let orderAttributes = '';
        if ((window.AnalyticsConstants && window.AnalyticsConstants.isServerSideActive) || window.cube.config.anly_useLegacy === 'N') {
          const fwk = window.cube.config.anly_useLegacy === 'Y' ? CUBE.Analytics : CUBE.Anly;
          const jsonGACommon = `"ga_common" : "${encodeURIComponent(fwk.serverside.getGACommon())}"`;
          const jsonGADimensions = `"ga_dimensions" : "${encodeURIComponent(
            fwk.serverside.getGADimensions()
          )}"`;

          orderAttributes = `{${jsonGACommon}, ${jsonGADimensions}}`;
        }

        const changePaymentMethodTag = cube.$id('change-payment-method');
        const changePaymentMethod = changePaymentMethodTag ? changePaymentMethodTag.value === 'true' : false;
        const redirectionUrl = window.onePay.config.redirectionUrl;

        const data = {
          orderId: window.onePay.data.order_id,
          orderAttributes,
          changePaymentMethod,
          redirectionUrl,
        };

        if (window && window.fiscalInvoiceData) {
          data.specialInstructions = JSON.stringify(window.fiscalInvoiceData);
        }

        return new Promise((resolve, reject) => {
          cube.ajax
            .form('rest/model/com/decathlon/cube/commerce/payment/PaymentActor/createOrder', data)
            .onSuccess(res => {
              enableButton();
              hideLoader();
              if (res.result && res.result.data) {
                if (res.result.data.redirectConfirmation && res.result.data.redirectionUrl) {
                  window.location.href = res.result.data.redirectionUrl;
                } else {
                  displayLoader();
                  resolve();
                }
              } else if (res.responseTO && res.responseTO.errors && res.responseTO.errors[0]) {
                cube.alert.error(res.responseTO.errors[0].message);
                reject(res.responseTO.errors[0].message);
              } else {
                cube.alert.error(i18n('PAY_0085'));
                reject(i18n('PAY_0085'));
              }
            })
            .onError(() => {
              cube.alert.error(i18n('checkout.createorder.error'));
              enableButton();
              hideLoader();
              reject(i18n('checkout.createorder.error'));
            })
            .call();
        });
      },
    },
  };
}

/**
 * Sometimes the configuration provided by the back-end will contains boolean values as string instead of symbols
 * this function makes sure we send proper booleans to one pay
 */
function parseBooleanValues(_, val) {
  if (val === 'true') return true;
  if (val === 'false') return false;
  return val;
}



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-onepay.js